import React from 'react';
import styles from './TierSummaryCard.module.css';
import { TierType } from '../storeTieringTypes';

interface TierSummaryCardProps {
  tier: TierType;
  stores: number;
  revenuePerWeek: string;
  description: string;
}

export const TierSummaryCard: React.FC<TierSummaryCardProps> = ({ tier, stores, revenuePerWeek, description }) => {
  return (
    <div className={`${styles.card} ${styles[`tier${tier}`]}`}>
      <div className={styles.header}>
        <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
        <span className={styles.tierLabel}>Tier {tier}</span>
      </div>
      <p className={styles.storeCount}>{stores} stores</p>
      <p className={styles.revenue}>{revenuePerWeek}</p>
      <div className={styles.divider} />
      <p className={styles.description}>{description}</p>
    </div>
  );
};
